import axiosInstance from "../axiosInstance";

// Get attachments by candidate ID
export const getAttachments = (candidateId) => {
  return axiosInstance.get(`/employee/getAttachments/${candidateId}`);
};

// Save attachment
export const saveAttachment = (candidateId, formData) => {
  return axiosInstance.post(
    `/employee/saveAttachment/${candidateId}`,
    formData,
  );
};

// Get address info
export const getAddressInfo = (candidateId) => {
  return axiosInstance.get(`/employee/address/get-address-info/${candidateId}`);
};

// save address
export const saveAddress = (formData) => {
  return axiosInstance.post("/employee/address/verify", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get assigned candidates info
// export const getAssignedCandidatesInfo = (status) => {
//   let url = "/employee/getAssignedCandidatesInfo";

//   if (status) {
//     url += `?candidateStatus=${status}`;
//   }

//   return axiosInstance.get(url);
// };

export const getAssignedCandidatesInfo = async (
  status,
  page = 0,
  size = 10,
  sortBy = "candidateId",
  sortDirection = "desc",
) => {
  return axiosInstance.get("/employee/getAssignedCandidatesInfo", {
    params: {
      candidateStatus: status || undefined,
      page,
      size,
      sortBy,
      sortDirection,
    },
  });
};

// Update candidate status
export const updateCandidateStatus = (candidateId, candidateRequest) => {
  return axiosInstance.post(
    `/employee/updateCandidateStatus/${candidateId}`,
    candidateRequest,
  );
};

// Get candidate info by ID
export const getCandidateInfo = (id) => {
  return axiosInstance.get(`/employee/candidateInfo/${id}`);
};

// Save criminal check
export const saveCriminalCheck = (payload) => {
  return axiosInstance.post(`/employee/criminal-check/save`, payload);
};

// Update criminal check status
export const updateCriminalCheckStatus = (candidateId, status, message) => {
  return axiosInstance.post(`/employee/criminal-check/update-status`, {
    candidateId,
    status,
    message,
  });
};

// Get education info
export const getEducationInfo = (candidateId) => {
  return axiosInstance.get(
    `/employee/education/get-education-info/${candidateId}`,
  );
};

// save education proofs
export const saveEducation = (formData) => {
  return axiosInstance.post(`/employee/education/verifyBackground`, formData);
};

// Get employment/physical info
export const getEmploymentPhysical = (candidateId) => {
  return axiosInstance.get(`/employee/get/employmentPhysical/${candidateId}`);
};

// save Physical employment proofs
export const savePhysicalEmployment = (formData) => {
  return axiosInstance.post(`/employee/verify`, formData);
};

// Virtual verification
export const vitualVerificationMail = (payload) => {
  return axiosInstance.post(`/employee/background-verification`, payload);
};

// save personal
export const savePersonal = (formData) => {
  return axiosInstance.post(`/employee/personal/verifyBackground`, formData);
};

// Get Employee Profile Info
export const getEmployeeProfileById = () => {
  return axiosInstance.get(`/employee/employeeId`);
};

// Update employee mobile number
export const updateEmployeeMobile = (mobileNumber) => {
  return axiosInstance.put(`/employee/updateEmployee?mobileNo=${mobileNumber}`);
};

// save Employment Check UAN
export const employmentCheckUAN = (candidateId, isVerified, uanRequestList) => {
  return axiosInstance.post(
    `/employee/employmentCheckUAN?candidateId=${candidateId}&isVerified=${isVerified}`,
    uanRequestList,
  );
};

// Upload utility bill
export const uploadUtilityBill = (formData) => {
  return axiosInstance.post(`/employee/utility-bill`, formData);
};

// Verify payslip & bank details
export const verifyPayslipBank = (formData) => {
  return axiosInstance.post(`/employee/verify-payslip-bank`, formData);
};

// Get recent notifications
export const getRecentNotifications = () => {
  return axiosInstance.get(`/employee/notification/recent`);
};

//Quick BGV end points
export const getAllCandidates = (search, page, size, sortBy, sortDirection) => {
  return axiosInstance.get(`/employee/QuickBgv/GetAll/candidates`, {
    params: { search, page, size, sortBy, sortDirection, },
  });
};

export const postQuickBgvCandidate = (formData) => {
  return axiosInstance.post(`/employee/QuickBgv/register/candidate`, formData);
};

export const updateQuickBgvCandidate = (formData, candidateId) => {
  return axiosInstance.put(
    `/employee/QuickBgv/Update/candidate/${candidateId}`,
    formData,
  );
};

export const getQuickBGVCandidateInfo = (id) => {
  return axiosInstance.get(`/employee/status/verification-status/${id}`);
};
export const getdigilocker = (payload) => {
  return axiosInstance.post("/employee/surepass/getDigilockerUrl", payload);
};

export const downloadAadhaar = (payload) => {
  return axiosInstance.post("/employee/surepass/downloadAadhaar", payload);
};
// Verify UAN from Surepass
export const verifyQuickUAN = (payload) => {
  return axiosInstance.post("/employee/surepass/verify-uan", payload);
};

// Verify Criminal from Surepass
export const verifyQuickCriminal = (payload) => {
  return axiosInstance.post(
    "/employee/criminal/check-user",
    // "/employee/criminal/test-user",
    payload,
  );
};

// save Criminal data
export const saveQuickCriminal = (payload) => {
  return axiosInstance.post("/employee/criminal-surpas-check/save", payload);
};
// update Criminal Status
export const updateQuickCriminalStatus = async (
  candidateId,
  status,
  checkStatus,
) => {
  return axiosInstance.patch(
    `/employee/criminal-surpas-check/candidate/${candidateId}/status`,
    null,
    {
      params: {
        status: status,
        checkStatus: checkStatus,
      },
    },
  );
};
// Save UAN Details
export const saveQuickUAN = (payload) => {
  return axiosInstance.post("/employee/uan/save", payload);
};

export const getS3key = (fileName) => {
  return axiosInstance.get(`/employee/proofs/stream`, {
    params: { key: fileName },
    responseType: "blob",
  });
};

//Get the average TAT of an employee
export const getAverageTat = (employeeid) => {
  return axiosInstance.get(
    `/admin/bgc-assignment/employee/${employeeid}/average-tat`,
  );
};

//Get the success rate of an employee
export const getSuccessRate = (employeeid) => {
  return axiosInstance.get(
    `/admin/bgc-assignment/employee/${employeeid}/success-rate`,
  );
};

export const fetchQuickBgvFinalReport = (candidateId) => {
  return axiosInstance.get(`/employee/bgv/final-report/${candidateId}`);
};

export const saveVirtualEmployment = (formData) => {
  return axiosInstance.post("/employee/verify/virtual", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
